import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Agent } from "../../../../../../../../../../services";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

const StatusCellContent: React.FC<StatusCellContent.Props> = ({ item }) => {
	const { t } = useTranslation();

	const content = useMemo(
		() => t(`statuses.${item.status?.level}`) || "",
		[item.status?.level, t],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace StatusCellContent {
	interface Props {
		item: Agent.Model;
	}
}

export default StatusCellContent;
